import styled, { keyframes, css, FlattenSimpleInterpolation } from 'styled-components';
import { CommonPluginContainer } from './CommonPluginContainer';

interface WheelContainerProps {
  winColor: string;
  loseColor: string;
  isEdition: boolean | undefined;
}

export const WheelContainer = styled(CommonPluginContainer)<WheelContainerProps>`
  position: relative;
  height: 80vh;
  width: 80vw;
  margin: auto;
  overflow: hidden;

  .cls-14, .cls-12, .cls-10, .cls-8 {
    fill: ${(props): string => props.loseColor};
  }

  .cls-15, .cls-13, .cls-11, .cls-9, .cls-4 {
    fill: ${(props): string => props.winColor};
  }

  ${(props): string => {
    if (props.isEdition === true) {
      return `
        &:hover {
          -webkit-box-shadow: inset 0 0 2px 0 black;
          box-shadow: inset 0 0 2px 0 black;
        }
      `;
    }
    return '';
  }}
`;
WheelContainer.displayName = 'WheelContainer';

const SpinAnimation = keyframes`
  0% {
    transform: rotate(0turn);
  }
  12.5% {
    transform: rotate(0.125turn);
  }
  25% {
    transform: rotate(0.25turn);
  }
  37.5% {
    transform: rotate(0.375turn);
  }
  50% {
    transform: rotate(0.5turn);
  }
  62.5% {
    transform: rotate(0.625turn);
  }
  75% {
    transform: rotate(0.75turn);
  }
  87.5% {
    transform: rotate(0.875turn);
  }
  100% {
    transform: rotate(1turn);
  }
`;

const WinAnimation = keyframes`
  from {
    transform: rotate(0turn);
  }
  to {
    transform: rotate(3.125turn);
  }
`;

const LoseAnimation = keyframes`
  from {
    transform: rotate(0turn);
  }
  to {
    transform: rotate(3turn);
  }
`;

interface SpinnerContainerProps {
  isPlaying: boolean;
  isStopping: boolean;
  hasWon: boolean | null;
}

export const SpinnerContainer = styled.div<SpinnerContainerProps>`
  position: absolute;
  height: calc(100% - 10vh);
  width: calc(100% - 10vw);
  top: 5vh;
  left: 5vw;
  right: 5vw;
  bottom: 5vh;
  transform-origin: center center;
  ${(props): FlattenSimpleInterpolation => {
    if (props.isPlaying === true && props.isStopping === false) {
      return css`
        animation-fill-mode: forwards;
        animation-name: ${SpinAnimation};
        animation-duration: 1s;
        animation-delay: 0ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      `;
    }
    if (props.isStopping) {
      const animationName = props.hasWon === true
        ? WinAnimation
        : LoseAnimation;
      return css`
        animation-name: ${animationName};
        animation-fill-mode: forwards;
        animation-duration: 5s;
        animation-delay: 0s;
        animation-iteration-count: 1;
        animation-timing-function: ease-out;
      `;
    }
    return css``;
  }}
`;
SpinnerContainer.displayName = 'SpinnerContainer';

export const NeedleContainer = styled.div`
  z-index: 3;
  position: absolute;
  width: 100%;
  top: 4vh;
  height: 10vh;
  transform-origin: center top;
`;
NeedleContainer.displayName = 'NeedleContainer';

export const WheelWinImage = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transform: rotate(45deg);

  img {
    transform-origin: 6vh 27vh;
    position: absolute;
    top: 8vh;
    width: 12vw;
    left: 29vw;
  }

  img:nth-child(2) {
    transform: rotate(90deg);
  }

  img:nth-child(3) {
    transform: rotate(180deg);
  }

  img:nth-child(4) {
    transform: rotate(270deg);
  }
`;
WheelWinImage.displayName = 'WheelWinImage';

export const WheelLostImage = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  img {
    transform-origin: center 29vh;
    position: absolute;
    top: 6vh;
    width: 8vw;
    left: 31vw;
  }

  img:nth-child(2) {
    transform: rotate(90deg);
  }

  img:nth-child(3) {
    transform: rotate(180deg);
  }

  img:nth-child(4) {
    transform: rotate(270deg);
  }
`;
WheelLostImage.displayName = 'WheelLostImage';
